import { Transition } from "@headlessui/react";
import { userService } from "../../services/user.service";
import { useEffect, useState } from "react";

const JoinGuildDoneModal = (props) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    props.setOpen(false);
    setOpen(false);
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  return (
    <Transition
      show={open}
      enter="transition-opacity duration-500"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
        <div className="relative my-6 mx-auto w-auto max-w-sm">
          {/*content*/}
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between rounded-t border-solid border-slate-200 p-1">
              <div className="mx-auto justify-center"></div>
            </div>
            {/*body*/}
            <div className="relative flex-auto p-6">
              <p className="text-md my-4 leading-relaxed text-slate-500">
                Joined Discord server successfully.
              </p>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end rounded-b border-t border-solid border-slate-200 p-6">
              <button
                className="background-transparent mr-1 mb-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none transition-all duration-150 ease-linear focus:outline-none"
                type="button"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </Transition>
  );
};

export default JoinGuildDoneModal;
